<template>
  <div>
    <Head title="Users" />
    <h1 class="mb-8 text-2xl font-bold">Data Pengguna</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Role:</label>
        <select v-model="form.role" class="w-full mt-1 form-select">
          <option :value="null" />
          <option value="admin">Admin</option>
          <option value="verifikator">Verifikator</option>
        </select>
      </search-filter>
      <Link v-if="can('write user')" class="btn-indigo" href="/users/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        <span class="hidden md:inline">&nbsp;User</span>
      </Link>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tr class="font-bold text-left">
          <th class="px-6 pt-6 pb-4">Nama Lengkap</th>
          <th class="px-6 pt-6 pb-4">User ID</th>
          <th class="px-6 pt-6 pb-4">Role</th>
          <th class="px-6 pt-6 pb-4">Login Terakhir</th>
          <th class="px-6 pt-6 pb-4">Aksi</th>
        </tr>
        <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="flex items-center px-6 py-4 focus:text-indigo-500">
              <img v-if="user.photo" class="block w-5 h-5 mr-2 -my-2 rounded-full" :src="user.photo" />
              {{ user.fullname }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 ml-2 fill-gray-400" />
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              {{ user.username }}
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              {{ user.roles.join(',') }}
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              <span v-if="user.last_login_at">{{ user.last_login_at }}</span>
              <span v-else class="text-gray-400">Belum pernah login</span>
            </div>
          </td>
          <td v-if="can('write user')" class="w-px p-4 border-t">
            <Link v-if="user.biodata_id" class="rounded-l btn-green-sm" :href="`/biodata/${user.biodata_id}/edit`">
              <font-awesome-icon icon="fas fa-magnifying-glass" />
            </Link>
            <Link class="rounded-l btn-indigo-sm" :href="`/users/${user.id}/edit`">
              <font-awesome-icon icon="fas fa-pencil" />
            </Link>
            <Link class="rounded-r btn-red-sm" @click.prevent="destroy(user.id)">
              <font-awesome-icon icon="fas fa-trash" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="5">No users found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/users', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/users/${id}`)
        }
      })
    },
  },
}
</script>
